<template>
    <div class="main-page-news" v-if="data && data.length">
        <div class="container">
            <div class="container--header">
                <h2 v-html="text.title"></h2>
                <a href="/press-center/news/" class="link link--arrow"><span v-html="text.allNews"></span></a>
            </div>
            <div class="main-page-news-slider">
                <div class="row row--40 swiper-wrapper">
                    <div
                        v-for="(item, i) of data"
                        :key="i"
                        class="col-default-3 col-mobile-12 main-page-news-slide swiper-slide"
                    >
                        <a :href="item.link" class="tile tile__link">
                            <div class="tile__img tile__img--labels">
                                <img :src="item.image" :alt="item.name">
                                <span class="tile__img--tag" v-if="item['press-release']" v-html="text.press"></span>
                            </div>
                            <div class="tile__body">
                                <span class="tile__title" v-html="item.name"></span>
                                <div class="details">
                                    <time :datetime="item.date | momentFilter()" class="details__date">{{ item.date | momentFilter('D MMMM YYYY') }}</time>
                                    <div class="details__body">
                                        <span class="details__tag" v-html="item.type"></span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
            <div class="container--line"></div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import Swiper from 'swiper/dist/js/swiper.js'

export default {
    name: 'MainPageNews',
    props: {
        data: {
            type: Array
        }
    },
    data() {
        return {
            slider: null,
            text: {
                press: localize({
                    'ru': 'Пресс-релиз',
                    'en': 'Press release'
                }),
                title: localize({
                    'ru': 'Новости',
                    'en': 'News'
                }),
                allNews: localize({
                    'ru': 'Все новости',
                    'en': 'All news'
                })
            }
        }
    },
    methods: {
        initSlider () {
            this.slider = new Swiper ('.main-page-news-slider', {
                slidesPerView: 1,
                spaceBetween: 10
            })
        }
    },
    mounted () {
        if (this.device === 'v-mobile' || this.device === 'mobile') {
            this.initSlider()
        }
    },
    watch: {
        device (value) {
            if (value === 'v-mobile' || value === 'mobile') {
                if (this.slider === null) {
                    this.initSlider()
                }
            } else {
                if (this.slider !== null) {
                    this.slider.destroy(true, true)
                    this.slider = null
                }
            }
        }
    },
    computed: {
        device () {
            return this.$store.getters.device
        }
    }
}
</script>



// WEBPACK FOOTER //
// frontend/components/main-page/components/news-list/index.vue